import "./EducationField.css";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import { useState } from "react";
import ButtonV2 from "../../components/ButtonV2";
import Document from "../DocumentsPage/Document.js";

const EducationField = (props) => {
  //stav pro zapis popup
  const [showPopup, setShowPopup] = useState(false);

  //metody pro popup a zavreni popupu
  const handleButtonClick = () => {
    setShowPopup(true);
  };

  const handleClose = () => {
    setShowPopup(false);
  };

  //? test
  //? console.log("EducationField", props);
  return (
    <div className="education-field p-3">
      <h2 className="left-border">{props.data.name}</h2>
      <b>Kód: </b>
      {props.data.code}
      <br />
      <br />
      <b>Vzdělávací program:</b>

      <BlocksRenderer
        content={Array.isArray(props?.data?.program) ? props.data.program : []}
      ></BlocksRenderer>
      <div className="section-divider m-1"></div>
      <div className="accordion m-3" id="accordionPanelsStayOpenExample">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseOne"
              aria-expanded="true"
              aria-controls="panelsStayOpen-collapseOne"
            >
              <b>Vstupní požadavky</b>
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseOne"
            className="accordion-collapse collapse"
          >
            <div className="accordion-body">
              <BlocksRenderer
                content={
                  Array.isArray(props?.data?.requirements)
                    ? props.data.requirements
                    : []
                }
              ></BlocksRenderer>
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseTwo"
              aria-expanded="false"
              aria-controls="panelsStayOpen-collapseTwo"
            >
              <b>Očekávané výstupy</b>
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseTwo"
            className="accordion-collapse collapse"
          >
            <div className="accordion-body">
              <BlocksRenderer
                content={
                  Array.isArray(props?.data?.outputs) ? props.data.outputs : []
                }
              ></BlocksRenderer>
              <br />
              <br />
            </div>
          </div>
        </div>

        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#panelsStayOpen-collapseThree"
              aria-expanded="true"
              aria-controls="panelsStayOpen-collapseOne"
            >
              <b>Rozvrh hodin</b>
            </button>
          </h2>
          <div
            id="panelsStayOpen-collapseThree"
            className="accordion-collapse collapse"
          >
            <div className="accordion-body">
              <table className="timetable w-100">
                <thead>
                  <tr>
                    <th>Vyučovací předměty</th>
                    <th>Týdenní hodinová dotace</th>
                  </tr>
                </thead>
                <tbody>
                  {props.data.timetable.map((subject) => (
                    <tr key={subject.id}>
                      <td>{subject.name}</td>
                      <td>{subject.hours}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      {props.data.duration && (
        <>
          <div className="left-border">
            <strong>Délka vzdělávacího programu:</strong>
            <br />
            {props.data.duration}
          </div>
          <br />
        </>
      )}
      {props.data.form && (
        <>
          <div className="left-border">
            <strong>Forma studia:</strong>
            <br />
            {props.data.form}
          </div>
          <br />
        </>
      )}
      {props.data.graduation && (
        <>
          <div className="left-border">
            <strong>Způsob ukončení:</strong>
            <br />
            {props.data.graduation}
          </div>
          <br />
        </>
      )}
      {props.data.educationLevel && (
        <>
          <div className="left-border">
            <strong>Dosažený stupeň vzdělání:</strong>
            <br />
            {props.data.educationLevel}
          </div>
          <br />
        </>
      )}
      {props.document && (
        <>
          <div className="news-doc">
            <Document name={props.document.name} fileUrl={props.document.url} />
          </div>
        </>
      )}
      <div className="d-flex justify-content-center m-3">
        <div onClick={handleButtonClick}>
          <ButtonV2 text="Zápis" />
        </div>
        {showPopup && (
          <div className="popup">
            <div className="popup-content">
              <h3>{props.modal.title}</h3>
              <BlocksRenderer
                content={
                  Array.isArray(props?.modal?.text) ? props.modal.text : []
                }
                blocks={{
                  image: ({ image }) => (
                    <img
                      src={image.url}
                      alt={image.alternativeText}
                      className="blocks-renderer-img"
                    />
                  ),
                  list: ({ children, format }) =>
                    format === "unordered" ? (
                      <ul className="blocks-renderer-ul">{children}</ul>
                    ) : (
                      <ol className="blocks-renderer-ol">{children}</ol>
                    ),
                }}
              ></BlocksRenderer>
              <div
                className="d-flex flex-column align-items-center"
                onClick={handleClose}
              >
                <ButtonV2 text="Zavřít" />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default EducationField;
